export default "__VITE_ASSET__283ab41a__"